import { GenericRemoteActionBuilder } from '../remote-action-builder';
import { Injectable, ViewContainerRef, ComponentRef } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { RemoteAction } from '../../remote-action';
import { TimeCorrectionRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/time-correction-remote-action-builder-ui-step/time-correction-remote-action-builder-ui-step';
import { TimeCorrectionComponent } from 'src/app/_components/remote-action-step/time-correction/time-correction.component';

import { LocationService } from 'src/app/_services/location/location.service';
import { EmployeeService } from 'src/app/_services/employee/logic/employee.service';
import { ServicejobSelectRemoteActionBuilderUIStep } from '../../remote-action-builder-steps/servicejob-select-remote-action-builder-ui-step/servicejob-select-remote-action-builder-ui-step';
import { PlaceTypeRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/placetype-remote-action-builder-service-step/placetype-remote-action-builder-service-step';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { ServicejobSelectRaStepComponent } from 'src/app/_components/remote-action-step/servicejob-select-ra-step/servicejob-select-ra-step.component';
import { TravelRemoteActionType } from './travel-remote-action-type';
import { ServicejobIdRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/servicejob-id-remote-action-builder-service-step/servicejob-id-remote-action-builder-service-step';
import { ServicejobsService } from 'src/app/_services/servicejobs/logic/servicejobs.service';
import { ActivityTypeSelectRemoteActionBuilderUIStep } from '../../remote-action-builder-steps/activity-type-select-remote-action-builder-ui-step/activity-type-select-remote-action-builder-ui-step';
import { KeywordSelectRemoteActionBuilderUIStep } from '../../remote-action-builder-steps/keyword-select-remote-action-builder-ui-step/keyword-select-remote-action-builder-ui-step';
import { GpsRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/gps-remote-action-builder-service-step/gps-remote-action-builder-service-step';
import { TargetServicejobIdRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/target-servicejob-id-remote-action-builder-service-step/target-servicejob-id-remote-action-builder-service-step';
import { REMOTE_ACTION_EDIT } from 'src/app/_components/remote-action-step/remote-action-step.component';
import { Place } from 'src/app/_model/place';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { ExecutedWorkRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/executed-work-remote-action-builder-ui-step/executed-work-remote-action-builder-ui-step';
import { TeamRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/team-remote-action-builder-service-step/team-remote-action-builder-service-step';
import { BranchesService } from 'src/app/_services/branches/logic/branches.service';
import { DriverSelectRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/driver-select-remote-action-builder-ui-step/driver-select-remote-action-builder-ui-step';
import { KmSelectRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/km-select-remote-action-builder-ui-step/km-select-remote-action-builder-ui-step';
import { PaidMealsSelectRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/paid-meal-select-remote-action-builder-ui-step/paid-meal-select-remote-action-builder-ui-step';
import { PlaceType } from 'src/app/_model/placetype';
import { KmSelectComponent } from 'src/app/_components/remote-action-step/km-select/km-select.component';
import { OtherPlaceTextRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/other-place-text-remote-action-builder-ui-step/other-place-text-remote-action-builder-ui-step';
import { JobSectionRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/jobsection-select-remote-action-builder-ui-step/jobsection-select-remote-action-builder-ui-step';
import { JobSectionsService } from 'src/app/_services/job-section/logic/job-section.service';
import { JobSectionSelectRaStepComponent } from 'src/app/_components/remote-action-step/jobsection-select-ra-step/jobsection-select-ra-step.component';
import { LBSUtils } from 'src/app/_util/lbs-utils';

@Injectable()
export class TravelRemoteActionBuilder extends GenericRemoteActionBuilder {
  constructor(
    private type: TravelRemoteActionType,
    appService: AppService,
    credentialsService: CredentialsService,
    private servicejobService: ServicejobsService,
    private branchService: BranchesService,
    locationService: LocationService,
    employeeService: EmployeeService,
    jobSectionsService: JobSectionsService,
    private clientStateService: ClientStateService,
    private appParameterService: AppParameterService,
    private logger?: LoggingService,
    private allowGPTarget: boolean = false
  ) {
    super(
      type.pageTitle,
      appService,
      credentialsService,
      {
        endpoint: type.endpoint,
        data: {},
        cachable: true,
        fifo: true,
        authenticationRequired: true,
        shortLabel: type.raShortLabel,
        shortLabelTranslate: true,
      },
      // UI Steps
      // In case we end the service job there is no selection of a new servicejob
      type === TravelRemoteActionType.DEPART
        ? []
            .concat(
              clientStateService.theState.getValue().serviceJobId !==
                undefined &&
                appParameterService.appParameters$
                  .getValue()
                  .getBooleanParameter('imsmc.job.reportexecutedwork', true)
                ? [new ExecutedWorkRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat(
              clientStateService.theState.getValue().serviceJobId !==
                undefined &&
                appParameterService.appParameters$.getValue()[
                  'imsmc.job.reportactivitytype'
                ]
                ? [new ActivityTypeSelectRemoteActionBuilderUIStep(logger)]
                : []
            )
            .concat(
              clientStateService.theState.getValue().serviceJobId !==
                undefined &&
                appParameterService.appParameters$.getValue()[
                  'imsmc.use.keyword'
                ]
                ? [new KeywordSelectRemoteActionBuilderUIStep(logger)]
                : []
            )
            .concat([
              new ServicejobSelectRemoteActionBuilderUIStep(logger),
              new OtherPlaceTextRemoteActionBuilderUiStep(logger),
              new JobSectionRemoteActionBuilderUiStep(
                jobSectionsService,
                logger
              ),
              new JobSectionRemoteActionBuilderUiStep(
                jobSectionsService,
                logger
              ),
              new JobSectionRemoteActionBuilderUiStep(
                jobSectionsService,
                logger
              ),
              new JobSectionRemoteActionBuilderUiStep(
                jobSectionsService,
                logger
              ),
            ])
            .concat(
              appParameterService.appParameters$.getValue()[
                'imsmc.tripgen.usedriverflag'
              ] == true &&
                clientStateService.theState.getValue().serviceJobId ===
                  undefined &&
                (clientStateService.theState.getValue().place?.placeType ===
                  PlaceType.EMP_HOME ||
                  clientStateService.theState.getValue().place?.placeType ===
                    PlaceType.EMP_WORKPLACE)
                ? [new DriverSelectRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat(
              appParameterService.appParameters$.getValue()[
                'imsmc.tripgen.submitkm'
              ] &&
                clientStateService.theState.getValue().place &&
                (clientStateService.theState.getValue().place.placeType ===
                  PlaceType.EMP_HOME ||
                  clientStateService.theState.getValue().place.placeType ===
                    PlaceType.EMP_WORKPLACE) &&
                clientStateService.theState.getValue().dpFlag !== 'dpp'
                ? [new KmSelectRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat([new TimeCorrectionRemoteActionBuilderUiStep(logger)])
        : // Arrive
          []
            .concat(
              appParameterService.appParameters$.getValue()[
                'imsmc.tripgen.submitpaidmeals'
              ] == true &&
                clientStateService.theState.getValue().targetServiceJobId ===
                  undefined &&
                clientStateService.theState.getValue().targetPlace &&
                (clientStateService.theState.getValue().targetPlace
                  .placeType === PlaceType.EMP_HOME ||
                  clientStateService.theState.getValue().targetPlace
                    .placeType === PlaceType.EMP_WORKPLACE)
                ? [new PaidMealsSelectRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat(
              appParameterService.appParameters$.getValue()[
                'imsmc.tripgen.submitkm'
              ] == true &&
                clientStateService.theState.getValue().dpFlag !== 'dpp'
                ? [new KmSelectRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat([new TimeCorrectionRemoteActionBuilderUiStep(logger)]),
      // Service Steps
      // In case we end or change the service job we need to transmit the current servicejob
      type === TravelRemoteActionType.DEPART
        ? []
            .concat(
              clientStateService.theState.getValue().serviceJobId !== undefined
                ? [
                    new ServicejobIdRemoteActionBuilderServiceStep(
                      clientStateService,
                      servicejobService,
                      logger
                    ),
                  ]
                : [
                    new PlaceTypeRemoteActionBuilderServiceStep(
                      clientStateService,
                      logger
                    ),
                  ]
            )
            .concat([
              new TeamRemoteActionBuilderServiceStep(
                employeeService,
                clientStateService,
                logger
              ),
            ])
            .concat([
              new GpsRemoteActionBuilderServiceStep(locationService, logger),
            ])
        : // Arrive
          [
            new TargetServicejobIdRemoteActionBuilderServiceStep(
              clientStateService,
              servicejobService,
              branchService,
              logger
            ),
            new TeamRemoteActionBuilderServiceStep(
              employeeService,
              clientStateService,
              logger
            ),
            new GpsRemoteActionBuilderServiceStep(locationService, logger),
          ],
      async (data: any) => {
        logger.log(
          this.constructor.name,
          ' Executing post generate function',
          data
        );

        if (data['dpflag']) {
          await this.clientStateService.setDpFlag(data['dpflag']);
        }

        // JB20191022: Servicejob or PT was transmitted. Set them as destination for the travel
        if (type === TravelRemoteActionType.DEPART) {
          if (data['next_sjobid']) {
            const checkedSJob = this.servicejobService.getServiceJobById(
              data['next_sjobid']
            );
            if (checkedSJob) {
              await this.clientStateService.startTravel(
                checkedSJob.id,
                undefined,
                undefined
              );
            } else {
              this.logger.log(
                this.constructor.name,
                'provided sjob id is not available, try finding sjob by secondarykey',
                data['next_sjob_secondarykey']
              );

              if (data['next_sjob_secondarykey']) {
                const foundSjobsBySecondaryKey =
                  this.servicejobService.servicejobs$
                    .getValue()
                    .filter((val) => {
                      return (
                        data['next_sjob_secondarykey'] ===
                          val.appaccountingnumber ||
                        data['next_sjob_secondarykey'] === val.accountingnumber
                      );
                    });

                if (
                  foundSjobsBySecondaryKey &&
                  foundSjobsBySecondaryKey.length > 0
                ) {
                  if (foundSjobsBySecondaryKey.length === 1) {
                    await this.clientStateService.startTravel(
                      foundSjobsBySecondaryKey[0].id,
                      undefined,
                      undefined
                    );
                  } else {
                    this.logger.warn(
                      this.constructor.name,
                      'Found multiple sjobs for skey take first one'
                    );
                    await this.clientStateService.startTravel(
                      foundSjobsBySecondaryKey[0].id,
                      undefined,
                      undefined
                    );
                  }
                } else {
                  this.logger.error(
                    this.constructor.name,
                    'Warning no secondary key sjob found'
                  );
                }
              }
            }
          } else if (data['next_branchid']) {
            this.clientStateService.startTravel(
              undefined,
              undefined,
              data['next_branchid']
            );
          } else if (data['next_pt']) {
            this.logger.log(
              this.constructor.name,
              'PT Debug Travel RA Builder data of selected pt',
              data
            );
            const nextPlace = new Place({
              placeType: data['next_pt'],
              otherText: data['next_destinationInfo'],
            });
            this.clientStateService.startTravel(
              undefined,
              nextPlace,
              undefined
            );
          }

          if (data['curjsid']) {
            logger.log(
              this.constructor.name,
              'found jobsection id in remote action update clientstate',
              data['curjsid']
            );
            await this.clientStateService.setJobSectionId(data['curjsid']);
          }
        } else {
          this.clientStateService.stopTravel();
        }
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    let ra = await super.generateRemoteAction(dataValues);

    if (ra.data['next_sjobid']) {
      let sjob = this.servicejobService.getServiceJobById(
        ra.data['next_sjobid']
      );

      ra.data[REMOTE_ACTION_EDIT.LONGLABEL] = sjob.label;
      ra.data[REMOTE_ACTION_EDIT.LONGLABELTRANSLATE] = false;
    } else if (ra.data['next_branchid']) {
      let branch = this.branchService.getBranchById(ra.data['next_branchid']);
      ra.data[REMOTE_ACTION_EDIT.LONGLABEL] = branch.displayLabel;
      ra.data[REMOTE_ACTION_EDIT.LONGLABELTRANSLATE] = false;
    } else if (ra.data['selected_pt']) {
      let place = new Place({
        placeType: ra.data['selected_pt'],
      });
      ra.data[REMOTE_ACTION_EDIT.LONGLABEL] = place.title;
      ra.data[REMOTE_ACTION_EDIT.LONGLABELTRANSLATE] = false;
    }

    return ra;
  }

  public generateComponent(
    viewContainerRef: ViewContainerRef
  ): ComponentRef<any> {
    const componentRef = super.generateComponent(viewContainerRef);
    const appParams = this.appParameterService.appParameters$.getValue();

    if (componentRef.instance instanceof TimeCorrectionComponent) {
      this.logger.log(
        this.constructor.name,
        'Generate Component of Type TimeCorrectionComponent report servicejob'
      );
      (<TimeCorrectionComponent>componentRef.instance).setDescription(
        this.type.descriptionKey
      );
      (<TimeCorrectionComponent>componentRef.instance).setTitle(
        this.type.titleKey
      );
  
      if (appParams != undefined) {
        switch (this.type) {
          case TravelRemoteActionType.ARRIVE:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.arrive',
                false
              );
            break;
          case TravelRemoteActionType.DEPART:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.depart',
                false
              );
            break;
        }
      }
    }
    // Configure specific Components
    if (componentRef.instance instanceof ServicejobSelectRaStepComponent) {
      // Tell the component to also show Placetypes
      (<ServicejobSelectRaStepComponent>componentRef.instance).showPlacetypes();
      (<ServicejobSelectRaStepComponent>(
          componentRef.instance
        )).isTravelSelector = true;
      if (this.allowGPTarget === true) {
        (<ServicejobSelectRaStepComponent>(
          componentRef.instance
        )).allowGpTarget();
      }
      if (appParams?.getBooleanParameter("imsmc.remoteaction-step.notify-travel.hide-finished", true) ?? true) {
        (<ServicejobSelectRaStepComponent>(
          componentRef.instance
        )).hideFinishedServicejobs();
      }
    }

    // Configure specific Components
    if (componentRef.instance instanceof JobSectionSelectRaStepComponent) {
      const currentData = super.getRemoteActionData();
      const appParams = this.appParameterService.appParameters$.getValue();
      if (
        LBSUtils.convertStringBool(
          appParams[
            'imsmc.remoteaction-step.jobsection-select.allow-branch-sections.sow'
          ],
          false
        )
      ) {
        (<JobSectionSelectRaStepComponent>(
          componentRef.instance
        )).allowBranchSelection();
      }

      if (currentData['curjsid']) {
        (<JobSectionSelectRaStepComponent>(
          componentRef.instance
        )).parentJobSectionId = currentData['curjsid'];
      } else if (currentData['next_sjobid']) {
        (<JobSectionSelectRaStepComponent>componentRef.instance).sjobId =
          currentData['next_sjobid'];
      }
    }

    // Configure specific Components
    if (componentRef.instance instanceof KmSelectComponent) {
      // Tell the component to also show Placetypes
      if (this.type === TravelRemoteActionType.ARRIVE) {
        (<KmSelectComponent>componentRef.instance).isArrive = true;
      }

      if (this.type === TravelRemoteActionType.DEPART) {
        (<KmSelectComponent>componentRef.instance).isDepart = true;
      }
    }

    return componentRef;
  }
}
